export default __webpack_public_path__ + "static/media/accessible.8bcc05af.svg";